// Builds TaskListContent tree wrapped in TaskUIProvider.
import { TaskUIProvider } from '@/features/tasks/context/TaskUIContext';
import TaskListContent from './TaskListContent';

export function buildTaskListBaseContent({
  uiContextValue,
  taskListRef,
  tasks,
  tasksMap,
  showBreadcrumbs,
  view,
  topActionableTaskId,
  showPlayButtonAlways,
  handleFocus,
  handleBlur,
  indentationType,
  newTaskInputIndex,
  handleSaveNewTask,
  handleCancelNewTaskInput,
  triggeringKey,
  editingTaskId,
  handleSave,
  handleStopEditingAndRestoreSelection,
  addingSubtaskTo,
  handleStartAddingSubtask,
  handleSaveSubtask,
  handleCancelAddSubtask,
  onBeforeToggleComplete,
  listTabIndex,
  itemTabIndex,
}) {
  return (
    <TaskUIProvider value={uiContextValue}>
      <TaskListContent
        taskListRef={taskListRef}
        tasks={tasks}
        tasksMap={tasksMap}
        showBreadcrumbs={showBreadcrumbs}
        view={view}
        topActionableTaskId={topActionableTaskId}
        showPlayButtonAlways={showPlayButtonAlways}
        listTabIndex={listTabIndex}
        itemTabIndex={itemTabIndex}
        handleFocus={/** @type {any} */ (handleFocus)}
        handleBlur={/** @type {any} */ (handleBlur)}
        indentationType={/** @type {any} */ (indentationType)}
        newTaskInput={{
          index: newTaskInputIndex,
          onSave: handleSaveNewTask,
          onCancel: handleCancelNewTaskInput,
          triggeringKey,
        }}
        editing={{
          editingTaskId,
          onSave: handleSave,
          onCancel: handleStopEditingAndRestoreSelection,
        }}
        subtask={{
          addingSubtaskTo,
          onStartAdding: handleStartAddingSubtask,
          onSave: handleSaveSubtask,
          onCancel: handleCancelAddSubtask,
          onBeforeToggleComplete,
        }}
      />
    </TaskUIProvider>
  );
}
